var render = function render(){var _vm=this,_c=_vm._self._c;return _c('open-banking-description-step',{staticClass:"obk-description-no-incognito-step",attrs:{"step-number":_vm.stepNumber},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('div',[_vm._v("כדאי לשים שהדפדפן במצב רגיל (לא /גלישה פרטית incognito)")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }